import axios from 'axios';
import {getChecklistContainerId} from '../app/selectors';
import {ENV_CONFIGS} from '../constants/envs';
import {mapDataToClientSide} from '../utils/checklist-helper';
import {getToken} from '../utils/getToken';

const allowedInstanceAttributs = ['id', 'title', 'status', 'urn', 'instanceContainerId'];
const allowedSectionAttributes = ['id', 'title', 'status', 'urn', 'number'];
const allowedItemAttributs = ['id', 'title', 'urn'];
const includeTypes = ['sections', 'sections.items'];

export const getChecklistData = ({urns, getState, dispatch}) =>
  getToken({getState, dispatch})
    .then(token => {
      const containerId = getChecklistContainerId(getState());
      const apiUrl = `${ENV_CONFIGS.APIGEE_HOST}/bim360${ENV_CONFIGS.CHECKLIST}/containers/${containerId}/instances`;
      return axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          'queryFilter[urn]': urns.join(','),
          'fields[instances]': allowedInstanceAttributs.join(','),
          'fields[instance_sections]': allowedSectionAttributes.join(','),
          'fields[instance_items]': allowedItemAttributs.join(','),
          include: includeTypes.join(',')
        }
      });
    })
    .then(mapDataToClientSide);
